exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".column-1[data-v-73560fb4],.column-2[data-v-73560fb4]{width:50%}", "", {"version":3,"sources":["/opt/build/repo/src/views/Discover.vue"],"names":[],"mappings":"AACA,sDAEE,SAAW,CACZ","file":"Discover.vue","sourcesContent":["\n.column-1[data-v-73560fb4],\n.column-2[data-v-73560fb4] {\n  width: 50%;\n}"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-73560fb4","scoped":true,"hasInlineConfig":true}!./node_modules/stylus-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/Discover.vue
// module id = 191
// module chunks = 5